import { connect } from "react-redux";

var moment = require("moment");

var Features = require("lib/account/Features");
var CurrentUser = require("lib/account/CurrentUser");

var BookDisplay = require("components/reading/books/BookDisplay")
var ReadingLevelDisplay = require("components/reading/reading_levels/ReadingLevelDisplay")
var GradeLevel = require("lib/academic/GradeLevel");
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");
var PaywallModal = require("components/users/teachers/PaywallModal");
var Glyphicon = require("components/utility/icons/Glyphicon");
var Spinner = require("components/utility/Spinner");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var UIActions = require("lib/actions/UIActions");

require("data/reading_level_graph.scss");

@connect(
	(state, props) => {
		var downProps = {};

		downProps.clozeEnabled = Features.isEnabled(Features.CLOZE_ASSESSMENTS);
		downProps.lexileFormat = CurrentUser.get().prefs.reading_level_format;

		if (props.studentID) {
			var student = RosterSelectors.student({ state, id: props.studentID });
			if (student) {
				downProps.studentName = student.first_name;
			}
		}

		if (student && _.isEmpty(props.readingLevels)) {
			downProps.useGradeLevelRange = true;
			downProps.gradeLevel = student.grade_level;
		}

		var currentYear = $wr.momentInTimezone(new Date()).year();
		var currentMonth = $wr.momentInTimezone(new Date()).month();

		if (props.numMonths) {
			downProps.numMonths = props.numMonths
			downProps.endDate = (new Date(currentYear, currentMonth + 1, 1)).getTime();
			downProps.startDate = (new Date(currentYear, currentMonth - props.numMonths, 1)).getTime();

		} else {
			var dateInfo = CurrentUser.fetchSchoolYearDates();

			downProps.startDate = dateInfo.startDate;
			downProps.endDate = dateInfo.endDate;
			downProps.numMonths = dateInfo.numMonths;
		}


		var books = _.select(props.books, (book) => {
			if (!book.lexile_score) { return false; }
			var dateVal = $wr.momentInTimezone(book.last_actives[props.studentID]).valueOf();
			return (dateVal > downProps.startDate) && (dateVal < downProps.endDate);
		});

		var bookData = _.map(books, function(book) {
			return _.extend({}, book, {
				reading_level: book.lexile_score,
				date: $wr.momentInTimezone(book.last_actives[props.studentID]).valueOf()
			});
		});

		downProps.bookData =  _.sortBy(bookData, "date");
		return downProps;
	},
	(dispatch) => ({
		openZpdPaywall: () => 
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.CLOZE_ASSESSMENTS })),
	})
)
class ReadingLevelGraph extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			loadedDependencies: false,
		}

		this.getRenderKey = this.getRenderKey.bind(this);
	}

	openPaywall(e) {
		$wr.nope(e)
		this.props.openZpdPaywall();
	}

	renderLegend() {
		if (this.props.useGradeLevelRange) {
			var zpdLabel = "Target reading range (default for " + GradeLevel.getName(this.props.gradeLevel) + ")";
			var name = this.props.studentName || "this student"

			var defaultMessage = (
				<span>
					This <em>Target Reading Range</em> (default) is based on grade level.
				</span>
			)

			var zpdTooltip = "This range of texts challenges students while still being understandable.";

		} else {
			var zpdTooltip = "This range of texts challenges students while still being understandable.";
			if (this.props.readingLevels && _.any(this.props.readingLevels)) {
				var assessmentIcon = (
					<span className="item">
						<span className="assessmentIcon" style={{ backgroundColor: ASSESSMENT_COLOR }} />{" "}
						Assessments
					</span>
				);				
			}
		}

		return (
			<div className="legend">
				<div>
					<span className="item">
						<span className="textIcon" style={{ backgroundColor: TEXT_COLOR }} />{" "}
						Texts (hover for details)
					</span>
					{ assessmentIcon }
					<span className="item text-left">
						<span className="zpdIcon" style={{ borderColor: ZPD_COLOR }} />{" "}
						Target Reading Range <Glyphicon icon="question-sign" dataTip={ zpdTooltip } />
					</span>
				</div>
			</div>
		)
	}

	//this method tries to force the chart to rerender each time it gets new data, so axis and info appear right
	getRenderKey(){
		let obj = {};
		if (this.props.gradeLevel){
			obj = {...obj, ...this.props.gradeLevel}
		}
		if (this.props.readingLevels){
			obj = {...obj, ...this.props.readingLevels}
		}
		return btoa(JSON.stringify(obj))
	}

	render() {
		if (!this.state.loadedDependencies) {
			return (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			)
		}

		var { startDate, endDate, numMonths, currentYear, currentMonth, bookData } = this.props;

		// always display at least DEFAULT_MIN_MONTHS months
		if (numMonths < DEFAULT_MIN_MONTHS) {
			numMonths = DEFAULT_MIN_MONTHS;
			endDate = (new Date(currentYear, currentMonth + DEFAULT_MIN_MONTHS, 1)).getTime();
		}

		var tickArray = [];
		for (var i = 1; i <= numMonths; i++) {
			tickArray.push(moment(startDate).add(i, "months").valueOf());
		}

		if (this.props.useGradeLevelRange) {
			var gradeLexile = ReadingLevelFormat.lexileForGrade(this.props.gradeLevel);

			var upperLevelData = [{
				reading_level: gradeLexile + LEXILE_OVER_ZPD,
				date: moment(startDate).valueOf()
			}, {
				reading_level: gradeLexile + LEXILE_OVER_ZPD,
				date: moment(endDate).valueOf()
			}]
			var lowerLevelData = [{
				reading_level: gradeLexile - LEXILE_UNDER_ZPD,
				date: moment(startDate).valueOf()
			}, {
				reading_level: gradeLexile - LEXILE_UNDER_ZPD,
				date: moment(endDate).valueOf()
			}]
		} else {
			// ZPD based on reading level assessments
			var readingLevelData = []
			var upperLevelData = []
			var lowerLevelData = []

			var sortedReadingLevels = _.sortBy(this.props.readingLevels, "created_at");
			let readingLevels = _.select(sortedReadingLevels, (readingLevel) => {
				var dateVal = $wr.momentInTimezone(readingLevel.created_at).valueOf();
				return (dateVal > startDate) && (dateVal < endDate);
			});

			if (readingLevels.length < 1) {
				readingLevels = [sortedReadingLevels[sortedReadingLevels.length - 1]];

				_.each(readingLevels, function (readingLevel) {
					var point = _.extend({}, readingLevel, {
						date: moment(startDate).valueOf()
					});

					readingLevelData.push(point);
					upperLevelData.push(_.extend({}, point, {
						reading_level: point.reading_level + LEXILE_OVER_ZPD
					}));
					lowerLevelData.push(_.extend({}, point, {
						reading_level: Math.max(point.reading_level - LEXILE_UNDER_ZPD, 0)
					}));
				});

				assessmentsScatter = null;
			} else {
				_.each(readingLevels, function (readingLevel) {
					var point = _.extend({}, readingLevel, {
						date: $wr.momentInTimezone(readingLevel.created_at).valueOf()
					});

					readingLevelData.push(point);
					upperLevelData.push(_.extend({}, point, {
						reading_level: point.reading_level + LEXILE_OVER_ZPD
					}));
					lowerLevelData.push(_.extend({}, point, {
						reading_level: Math.max(point.reading_level - LEXILE_UNDER_ZPD, 0)
					}));
				});

				var assessmentsScatter = (
					<Recharts.Scatter name="Assessments" data={readingLevelData}
										fill={ASSESSMENT_COLOR} shape="square" isAnimationActive={false}/>
				);
			}

			_.each([upperLevelData, lowerLevelData], (series) => {
				if (series.length > 0) {
					series.unshift({
						reading_level: series[0].reading_level,
						date: moment(startDate).valueOf()
					})
					series.push({
						reading_level: _.last(series).reading_level,
						date: moment(endDate).valueOf()
					})
				}
			});
		}

		var format = this.props.lexileFormat;

		function formatYLabel(yVal) {
			// Has to be string, or I'd use ReadingLevelDisplay
			var lexileFormatted = ReadingLevelFormat.getScoreForFormat(yVal, format);
			return lexileFormatted;
		}

		var yAxisLabel = "Reading Level (" + format + ")";

		var chartHeight = 350;

		return (
			<div className="readingLevelGraph">
				{ this.renderLegend() }
				<div className="yLabelWrap" style={ { height: (chartHeight - 100) } }>
					<div className="yLabel" style={ { maxWidth: (chartHeight - 150) } }>
						{ yAxisLabel }
					</div>
				</div>
				<div className="chartWrap">
					<Recharts.ResponsiveContainer height={ chartHeight } width="100%">
						<Recharts.ScatterChart key={this.getRenderKey()}>
							<Recharts.XAxis key={'x_' + this.getRenderKey()} dataKey={ "date" } name="Date" type="number"
								domain={ [startDate, endDate] } interval={ 0 }
								tick={<CustomizedAxisTick/> } ticks={ tickArray } tickCount={ numMonths + 2 } height={ 70 } />
							<Recharts.YAxis key={'y_' + this.getRenderKey()} dataKey={ "reading_level" } type="number" tickFormatter={ formatYLabel } name="Points" />
							<Recharts.ZAxis key={'z_' + this.getRenderKey()} range={ [100] }/>
							<Recharts.CartesianGrid stroke="#ddd" />
							<Recharts.Tooltip content={ <CustomTooltip studentID={ this.props.studentID } /> } />

							{ assessmentsScatter }

							<Recharts.Scatter name="ZPD" data={ upperLevelData } line={{ strokeWidth: 2 }}
								fill={ ZPD_COLOR } shape={ () => null } isAnimationActive={ false } />

							<Recharts.Scatter name="ZPD" data={ lowerLevelData } line={{ strokeWidth: 2 }}
								fill={ ZPD_COLOR } shape={ () => null } isAnimationActive={ false } />

							<Recharts.Scatter name="Texts" data={ bookData } fill={ TEXT_COLOR }
								shape="circle" isAnimationActive={ false } />
						</Recharts.ScatterChart>
					</Recharts.ResponsiveContainer>
				</div>
			</div>
		)
	}

	componentDidMount() {
		$wr.loadScript("/dependencies/recharts.min.js", "Recharts", () => {
			this.setState({ loadedDependencies: true });
		});
	}

};

class CustomizedAxisTick extends React.Component {
	render() {
		var { x, y, payload } = this.props;
 
		return (
			<g transform={ `translate(${x},${y})` }>
				<text x={ 0 } y={ 0 } dy={ 16 } textAnchor="end" fill="#555" transform="rotate(-35)">
					{ moment(new Date(payload.value)).format("MMM 'YY") }
				</text>
			</g>
		);
	}
};

var TOOLTIP_DATE_FORMAT = "MMM D, YYYY";

var LEXILE_OVER_ZPD = 50;
var LEXILE_UNDER_ZPD = 100;

var DEFAULT_MIN_MONTHS = 4;

var ASSESSMENT_COLOR = "#42af14";
var TEXT_COLOR = "#00a0f4";
var ZPD_COLOR = "#c0f2aa";

class CustomTooltip extends React.Component {
	render() {
		if (this.props.active) {
			var payload = this.props.payload[0].payload;

			if (payload.text_id) {
				// It's a book!
				var date = payload.last_actives[this.props.studentID];

				return (
					<div className="bookTooltip">
						<BookDisplay textID={ payload.text_id } contingentShowCover coverWidth={ 70 }>
							Level: <ReadingLevelDisplay lexile={ payload.reading_level } /><br />
							{ moment(date).format(TOOLTIP_DATE_FORMAT) }
						</BookDisplay>
					</div>
				);

			} else if (payload.origin) {
				var originText = ReadingLevelDisplay.ORIGIN_TEXTS[payload.origin];
				// It's a lexile assessment!
				return (
					<div className="assessmentTooltip">
						{ originText }<br />
						Level: <ReadingLevelDisplay lexile={ payload.reading_level } /><br />
						{ moment(new Date(payload.date)).format(TOOLTIP_DATE_FORMAT) }
					</div>
				);
			}

		}

		return null;
	}
};

class CustomizedShape extends React.Component {
	render() {
		return null;
	}
}

ReadingLevelGraph.propTypes = StrictPropTypes({
	books: PropTypes.array.isRequired,
	studentID: PropTypes.number,
	readingLevels: PropTypes.array,
	useGradeLevelRange: PropTypes.bool,
	gradeLevel: PropTypes.number,
	studentName: PropTypes.string,

	startDate: PropTypes.number,
	endDate: PropTypes.number,
	numMonths: PropTypes.number,
	currentYear: PropTypes.number,
	currentMonth: PropTypes.number,

	openZpdPaywall: PropTypes.func,

	clozeEnabled: PropTypes.string,
	lexileFormat: PropTypes.string
});

module.exports = ReadingLevelGraph;


// WEBPACK FOOTER //
// ./modules/components/data/ReadingLevelGraph.js